import { ChoiceOrdering } from '../../shared/enums/choice-ordering.enum';
import { Choice } from './choice.model';
import { Question } from './question.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class MultipleChoiceQuestion extends Question {
  public isMultipleChoice!: boolean;

  public ordering!: ChoiceOrdering;

  public choices!: Choice[];

  public static fromDto(dto: any): MultipleChoiceQuestion {
    const question: MultipleChoiceQuestion = new MultipleChoiceQuestion();
    Question.mapBaseProperties(question, dto);
    question.isMultipleChoice = dto.isMultipleChoice;
    question.ordering = dto.ordering;
    question.choices =
      dto.choices?.map((choiceDto: any) => Choice.fromDto(choiceDto)) ?? [];
    return question;
  }
}
